import ConvenioImportPage from "./ConvenioImportPage";

export {ConvenioImportPage}
export default ConvenioImportPage
